module.exports = __webpack_public_path__ + "static/media/logow.a8d48332.png";